
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {MatTreeModule} from "@angular/material/tree";
import {TranslateModule} from "@ngx-translate/core";
import {ModulePermissionComponent} from "./ui/modulePermission.component";
import {ModulesResolve} from "./providers/modules.resolve";
import {PermissionsResolve} from "./providers/permissions.resolve";
import {RolesResolve} from "./providers/roles.resolve";
import {SecurityRoutingModule} from "./security.routing";
import {ModuleRolePermissionsResolve} from "./providers/moduleRolePermissions.resolve";
import {IsGrantedDirective} from "./directive/isGranted.directive";
import {MatExpansionModule} from "@angular/material/expansion";
import {HasRoleDirective} from "./directive/hasRole.directive";
import {DisableRightClickDirective} from "./directive/disableRightClick.directive";
import {BlockCopyPasteDirective} from "./directive/blockCopyPaste.directive";

@NgModule({
    declarations: [
        ModulePermissionComponent,
        IsGrantedDirective,
        HasRoleDirective,
        DisableRightClickDirective,
        BlockCopyPasteDirective,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatTreeModule,
        TranslateModule,

        SecurityRoutingModule,
        MatExpansionModule,
    ],
    providers: [
        ModulesResolve,
        PermissionsResolve,
        RolesResolve,
        ModuleRolePermissionsResolve,
    ],
    exports: [
        IsGrantedDirective,
        HasRoleDirective,
        DisableRightClickDirective,
        BlockCopyPasteDirective,
    ],
    bootstrap: [
        ModulePermissionComponent,
    ]
})
export class SecurityModule { }
